<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Cihaz Sınıfı {{data ? 'Güncelle' : 'Ekle'}}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body" tabindex="0" ngbAutofocus>
    <form *ngIf="form" [formGroup]="form">
        <div class="col-xl-12 col-md-12 col-12 mb-1">
            <div class="form-group">
                <label for="name">Başlık</label>
                <input type="text" class="form-control" id="name" formControlName="name" placeholder="Başlık"
                    maxlength="250" />
            </div>
        </div>

        <div class="d-flex">
            <div class="form-group col-8">
                <label for="environmentalConditionId">Ortam Şartı</label>
                <ng-select [items]="environmentals" bindLabel="enviromentalContent" bindValue="id" formControlName="environmentalConditionId"></ng-select>
            </div>

            <div class="form-group col-4">
                <label for="status">Durum</label>
                <select class="form-control mx-25" formControlName="status">
                    <option value="true">Aktif</option>
                    <option value="false">Pasif</option>
                </select>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()" rippleEffect>
        İptal
    </button>
    <button type="button" class="btn btn-success" rippleEffect (click)="onSumbit()">
        {{data ? 'Güncelle' : 'Ekle'}}
    </button>
</div>